<section class="forgot-password">
  <form
    [formGroup]="forgotPasswordForm"
    class="container type--xs forgot-password__container"
    *ngIf="!result || (result && !result.Succeeded)"
    (submit)="requestPasswordReset(forgotPasswordForm.value)"
  >
    <h1 class="forgot-password__title">Forgot your password?</h1>
    <span class="forgot-password__subtitle"
      >Please enter your email address. We will send you an email to reset your
      password.</span
    >

    <mat-form-field class="full--width">
      <input
        matInput
        type="email"
        placeholder="Email address"
        formControlName="email"
      />
    </mat-form-field>

    <p class="error-message" *ngIf="result && !result.Succeeded">
      <span *ngIf="result.Error">{{ result.Error }}</span>
    </p>
    <div class="forgot-password__toolbar">
      <button
        type="submit"
        class="button forgot-password__toolbar__button"
        [disabled]="forgotPasswordForm.invalid"
        [class.is--loading]="loading"
      >
        Reset my password
      </button>
      <a [routerLink]="'/login'" class="link forgot-password__toolbar__button"
        >Back to login</a
      >
    </div>
  </form>

  <div
    class="container type--xs forgot-password__container"
    *ngIf="result && result.Succeeded"
  >
    <h1 class="forgot-password__title">Nearly there...</h1>
    <span class="forgot-password__subtitle"
      >An email has been sent to the email address you have entered ({{
        forgotPasswordForm.get('email').value
      }}). This email contains a link to create a new password.</span
    >
    <div class="forgot-password__toolbar">
      <a [routerLink]="'/login'" class="link forgot-password__toolbar__button"
        >Back to login</a
      >
    </div>
  </div>
</section>
